module.exports = __webpack_public_path__ + "static/media/clearspace-ideal.8f9e3648.svg";